import { Card, CardContent, Stack, Typography, useTheme } from "@mui/material/index";
import { FormTextField } from "../../common/form-fields-wrappers";
import { IExpiredActionInsertionForm } from "../../models/models";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { useParams } from "react-router-dom";
import { ExpiredInsertionAction, SMS_MAX_CHAR, TEXT_MAX_CHAR } from "../../config";
import { useRecoilValue } from "recoil";
import { expiredActionPropsState } from "../../state";

const TextCard = () => {

    const {t} = useTranslation(['expiredManagement']);
    const theme = useTheme();
    const expiredActionProps = useRecoilValue(expiredActionPropsState);

    const textWatch = useWatch<IExpiredActionInsertionForm, 'body'>({
        name: 'body'
    });
    const maxChar = (expiredActionProps?.actionType == ExpiredInsertionAction.NEW_SMS) ? SMS_MAX_CHAR : TEXT_MAX_CHAR;

    const isDisabled = [ExpiredInsertionAction.SMS1, ExpiredInsertionAction.SMS2, ExpiredInsertionAction.SMS3, ''].includes(expiredActionProps?.actionType || '');
    
    return (
        <Stack direction={"column"} gap={theme.spacing(1)}>
            <Typography >{t('action.form.body')}</Typography>
            <Card
                variant="outlined"
                sx={{
                    borderColor: 'primary.main'
                }}
            >
                <CardContent>
                    <FormTextField<IExpiredActionInsertionForm>
                        name="body"
                        placeholder={t('action.placeholder')}
                        disabled={isDisabled}
                        autoFocus
                        fullWidth
                        multiline
                        rows={10}
                        InputProps={{
                            disableUnderline: true
                        }}
                        error={isDisabled ? false : (textWatch.length > maxChar)}
                        helperText={isDisabled ? '' : (textWatch.length + ' / ' + maxChar)}
                        FormHelperTextProps={{
                            component: "div"
                        } as any}
                    />
                </CardContent>
            </Card>
        </Stack>

    )
}

export default TextCard;